import { Flex, Input, Modal, Spin } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";
import { CiCirclePlus } from "react-icons/ci";
import rpmService from "../../../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import { convertUTCDate } from "../../../../../../utils/convertionFunc";
import nodatafound from "../../../../../../Assets/Icons/NoDataCard2.svg";
import {
  fetchRpmReviewsList,
  setSelectedRpmPatient,
} from "../../../../../../Redux/actions/rpmActions";
import { FaRegClock } from "react-icons/fa6";
import dayjs from "dayjs";

function Index() {
  const [loader, setLoader] = useState(false);
  const [reviewModal, setReviewModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const { isLoading, reviewsList, selectedRpmPatient } = useSelector(
    (state) => state.rpm
  );

  useEffect(() => {
    const payload = {
      patientId: selectedRpmPatient.patientId,
      status: 1,
    };
    dispatch(fetchRpmReviewsList(payload));
  }, []);

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const handleReviewModal = () => {
    setReviewModal(!reviewModal);
  };

  const handleReviewSubmit = async () => {
    setLoader(true);
    const payload = {
      createdBy: loggedUser?.user?.userId,
      createdDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      description,
      givenDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      patientId: selectedRpmPatient.patientId,
      status: 1,
      title,
    };

    try {
      await rpmService.addNewReview(payload);
      setLoader(false);
      const reviewsPayload = {
        patientId: selectedRpmPatient.patientId,
        status: 1,
      };
      dispatch(fetchRpmReviewsList(reviewsPayload));
      setReviewModal(false);
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  return (
    <div>
      <div className="bg-blue-50 border-2 border-cyan-700 h-[300px] overflow-y-scroll scrollwidth rounded-lg p-4 shadow">
        <div className="flex justify-between">
          <p className="text-gray-800 font-medium text-base mb-2 ">Review</p>
          <button
            onClick={handleReviewModal}
            className="w-20 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
          >
            <span className="w-5 h-5">
              <CiCirclePlus className="w-full text-[#189FAA] h-full" />
            </span>
            <span className="">New</span>
          </button>
        </div>
        <div className="text-gray-600">
          <div
            className={`mt-3 ${isLoading === false && reviewsList?.length === 0
                ? "w-full flex justify-center items-center"
                : " h-[24rem]'"
              }`}
          >
            {isLoading && reviewsList?.length === 0 ? (
              <div className="flex items-center justify-center mt-[10%]">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : reviewsList?.length === 0 ? (
              <div className="flex flex-col items-center justify-center">
                <img
                  src={nodatafound}
                  alt="nodatafound"
                  className="h-24 w-24"
                />
                <p className="font-medium">No data found!!</p>
              </div>
            ) : (
              <div>
                <ul>
                  {reviewsList.map((item, idx) => (
                    // <li key={idx} className="border rounded-lg border-solid border-brand-primaryColor px-5 py-3 mb-3 bg-white">
                    //     <span>{item.title}</span>{" : "}<span>{item.description}</span>
                    // </li>
                    <div
                      className="border rounded-lg border-solid border-brand-primaryColor px-5 py-3 mb-3 bg-white"
                      key={idx}
                    >
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex text-brand-textBold  font-semibold text-base">
                          {item.title}
                        </div>
                        <div className="flex items-center text-brand-textBold  font-normal text-xs">
                          <FaRegClock width={14} height={12} />
                          {item.givenDate}
                        </div>
                      </div>
                      <div className="font-normal text-sm mt-3">
                        {item.description}
                      </div>
                    </div>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add new review */}
      <Modal
        title="Add Review"
        open={reviewModal}
        onCancel={handleReviewModal}
        footer={[]}
        destroyOnClose
      >
        <>
          <div className="space-y-4 mt-2 rounded-lg p-2">
            <div className="space-y-1">
              <label className="block text-sm font-medium text-gray-700">
                Title
              </label>
              <Input
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-sm font-medium text-gray-700">
                Description
              </label>
              <TextArea
                rows={4}
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
          <div className="flex items-center w-full justify-end my-5">
            <button className="border-brand-primaryColor bg-white border rounded text-brand-primaryColor text-sm px-6 py-1.5">
              Cancel
            </button>
            <button
              disabled={loader}
              onClick={handleReviewSubmit}
              className="bg-brand-primaryColor text-white border-brand-primaryColor border rounded px-5 py-1.5 text-brand-textWhite text-sm ml-3 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Submit
            </button>
          </div>
        </>
      </Modal>
    </div>
  );
}

export default Index;
